import { differenceInMinutes } from 'date-fns';
import { CenterMissingPayment, MissingPayment } from 'models';

export function getTotalHours(report: MissingPayment | CenterMissingPayment) {
    let totalMinutes = differenceInMinutes(new Date(report.end_date), new Date(report.start_date));
    if (report.break_minutes) {
        totalMinutes -= report.break_minutes;
    }
    return totalMinutes / 60;
}
